export const emojis = [
  '&#x1f600;',
  '&#x1f603;',
  '&#x1f609;',
  '&#x1f643;',
  '&#x1f642;',
  '&#x1f602;',
  '&#x1f923;',
  '&#x1f605;',
  '&#x1f606;',
  '&#x1f601;',
  '&#x1f604;',
  '&#x1f60d;',
  '&#x1f970;',
  '&#x1f607;',
  '&#x1f60a;',
  '&#x1f972;',
  '&#x1f619;',
  '&#x1f61a;',
  '&#x263a;',
  '&#x1f617;',
  '&#x1f618;',
  '&#x1f911;',
  '&#x1f61d;',
  '&#x1f92a;',
  '&#x1f61c;',
  '&#x1f61b;',
  '&#x1f60b;',
  '&#x1f914;',
  '&#x1f92b;',
  '&#x1f917;',
  '&#x1f976;',
  '&#x1f975;',
  '&#x1f927;',
  '&#x1f92e;',
  '&#x1f922;',
  '&#x1f912;',
  '&#x1f637;',
  '&#x1f634;',
  '&#x1f978;',
  '&#x1f973;',
  '&#x1f920;',
  '&#x1f92f;',
  '&#x1f9d0;',
  '&#x1f913;',
  '&#x1f60e;',
  '&#x1f479;',
  '&#x1f921;',
  '&#x1f4a9;',
  '&#x1f480;',
  '&#x1f624;',
  '&#x1f92c;',
  '&#x1f608;',
];
